import { ButtonGroup } from "data/CellComponent";
import {
  Instruction,
  ProgramContentType,
  InstructionWithContent,
  InstructionWithImage,
  Header1,
  InstructionWithTextarea,
  InstructionWithData,
} from "../BlockComponent";
import { LastCard, LastCardWithTextarea } from "./common";

export const Content_0_0_A = (isAiCoach?: boolean) => {
  return [
    Instruction("typography_0_0_0"),
    InstructionWithContent("typography_1_0_0", [
      [
        ButtonGroup(
          [
            {
              translationKey: "buttongroup_1_2_0_option0",
            },
            {
              translationKey: "buttongroup_1_2_0_option1",
            },
            {
              translationKey: "buttongroup_1_2_0_option2",
            },
            {
              translationKey: "buttongroup_1_2_0_option3",
            },
            {
              translationKey: "buttongroup_1_2_0_option4",
            },
          ],
          { id: "acquisition" }
        ),
      ],
    ]),
    InstructionWithImage("typography_2_0_0", "0"),
    InstructionWithImage("typography_3_0_0", "1"),
    Instruction("typography_4_0_0"),

    Header1(`typography_5_0_0`),
    Instruction("typography_6_0_0"),
    InstructionWithImage("typography_7_0_0", "2"),
    InstructionWithImage("typography_8_0_0", "3"),
    InstructionWithImage("typography_9_0_0", "4"),
    InstructionWithImage("typography_10_0_0", "5"),
    InstructionWithImage("typography_11_0_0", "6"),

    Header1(`typography_12_0_0`),
    InstructionWithImage("typography_13_0_0", "7"),
    Instruction("typography_14_0_0"),
    Instruction("typography_15_0_0"),

    Instruction("typography_16_0_0"),
    Instruction("typography_17_0_0"),
    Instruction("typography_18_0_0"),
    InstructionWithImage("typography_19_0_0", "8"),
    Instruction("typography_20_0_0"),
    Instruction("typography_21_0_0"),
    InstructionWithContent("typography_22_0_0", [
      [{ type: "sidebarOpenButton", content: {} }],
    ]),

    Instruction(`typography_23_0_0`),
    // Instruction(`typography_24_0_0`),
    // Instruction(`typography_25_0_0`),
    // InstructionWithContent("typography_26_0_0", [
    //   [{ type: "login", content: {} }],
    // ]),
    InstructionWithTextarea("typography_27_0_0", { id: "nickname" }),
    InstructionWithData({ A: { id: "nickname" } }, `typographyFromData_28_0_0`),
    InstructionWithContent("typography_29_0_0", [
      [{ type: "pushNotification", content: {} }],
    ]),

    Instruction("typography_30_0_0"),
    // ...LastCard,
    ...LastCardWithTextarea,
  ];
};
